<template>
  <div>
   <b-row no-gutters style="display: flex;align-items: center;justify-content: center;">
     <b-col md="12" >
       <b-card
       no-body
         class="overflow-auto card"
         style="padding:0;border-radius:0;"
       >
       
       <div class="panel" style="border-radius:0;">
        <div style="padding:20px;">
          <div style="display: flex; justify-content: space-between;margin-bottom:0px;padding:0px;padding-bottom:0px;">
            <strong
              class="float-left font-weight-black font-monospace"
              style="font-size: 1.3em;color:white;"
              > All Floates</strong
            >
           
            <b-button  v-if="$store.getters.role === 'Admin'"
            class="btn bg-gradient-danger"
            style="padding: 0;"
            v-b-modal="'post-update-modal-expense'"
            @click="resetform()"
          >
            <div class="top-1"></div>
            <span style="padding-left: 10px; padding-right: 10px;">
              <i class="fas fa-gamepad" style="margin-right: 10px"></i> Add Float
            </span>
            <div class="top-2"></div>
          </b-button>
          </div>
           </div>
         
         <div class="panel-body table-responsive">
           <datatable
             :columns="columns"
             :data="expenses.data"
             class="table table-striped text-nowrap table-bordered"
             style="text-align: center; color: white;"
           >
             <template slot-scope="{ row, index }">
               <tr>
                 <td class="align-middle">{{ index + 1 }}</td>
                 <td class="align-middle">{{row.description}}</td>
                 <td class="align-middle">{{row.agent.username}}</td>
                 <td class="align-middle">{{row.country.country+'('+row.country.currency+')'}}</td>
                 <td class="align-middle">{{formatNumber(row.amount)}}</td>
                 <td class="align-middle">{{ row.created_at | myDate }}</td>
                 <td class="align-middle">
                   <b-dropdown variant="link" no-caret right>
                     <template v-slot:button-content>
                       <i class="fas fa-ellipsis-v text-secondary"></i>
                     </template>
                     <b-dropdown-item @click="Editexpense(row, index)"  v-b-modal="'post-update-modal-expense'">
                       <i class="fa fa-edit text-secondary mr-2"></i> Edit
                     </b-dropdown-item>
                     <b-dropdown-item @click="deleteexpense(row.id, index)">
                       <i class="fas fa-trash-alt text-secondary mr-2"></i> Delete
                     </b-dropdown-item>
                   </b-dropdown>
                 </td>
               </tr>
             </template>
             
           </datatable>
           <template v-if="!expenses.data.length">
            <div class="text-center text-white py-3 w-100">
              <i class="fas fa-database fa-2x text-secondary"></i>
              <p class="mt-2"><strong>No Data Found</strong></p>
              <p>🔍 Try searching again or adding new data.</p>
            </div>
          </template>
         </div>
         
       </div>
         <div style="float:right;">
           <pagination :data="expenses" @pagination-change-page="getmyexpense">
              </pagination>
        </div>
       </b-card>
     </b-col>
   </b-row>
   <b-modal :id="'post-update-modal-expense'" :size="'md'">
         <div style="padding-left:20px;padding-top:15px;padding-bottom:5px;border-bottom:1px solid rgba(214,214,214);font-size:1.3em;">{{display?'Update Rate':'Add Rate'}} <span><i class="fas fa-times" style="float:right;margin-right:20px;margin-top:5px;color:grey;" @click="closemoadl('post-update-modal-expense')"></i></span></div>
     <form
        style="padding:30px;padding-top:15px;margin-bottom:35px;"
       @submit.prevent="display ? update() : create()"
     >
     <div class="form-group row">
      <label>Country</label>
      <select
      required
        v-model="expense.country"
        @change="updateuserholder"
        name="country"
        placeholder="country"
        class="form-control"
        :class="{ 'is-invalid': expense.errors.has('country') }"
      >
     <option value="">Select country</option>
     <option :value="contry.id" v-for="contry in countrys" :key="contry.id">{{contry.country}}</option>
     </select>
      <has-error :form="expense" field="country"></has-error>
    </div>
    <div class="form-group row">
      <label>Agent</label>
      <select
      required
        v-model="expense.user_id"
        name="user_id"
        placeholder="agent"
        class="form-control"
        :class="{ 'is-invalid': expense.errors.has('user_id') }"
      >
     <option value="">Select agent</option>
     <option :value="contry.id" v-for="contry in users_holder" :key="contry.id">{{contry.username}}</option>
     </select>
      <has-error :form="expense" field="country"></has-error>
    </div>
    <div class="form-group row">
      <label>Amount</label>
      <input
      required
        v-model="expense.amount"
        name="amount"
        placeholder="amount"
        class="form-control"
        :class="{ 'is-invalid': expense.errors.has('amount') }"
      />
      <has-error :form="expense" field="amount"></has-error>
    </div>
    <div class="form-group row">
      <label>Amount</label>
      <textarea
      required
        v-model="expense.description"
        name="description"
        placeholder="description"
        class="form-control"
        :class="{ 'is-invalid': expense.errors.has('description') }"
      ></textarea>
      <has-error :form="expense" field="description"></has-error>
    </div>
    
       <div  style='border-top:1px solid rgba(0.5,0.5,0.5,0.3);padding-top:10px;margin-top:15px;'>
       <div class="float-right">
         <b-button type="submit"  class="btn-primary" v-if="!display">
           Save
         </b-button>
         <b-button type="submit" class="btn-primary" v-if="display">
           Update
         </b-button>
       </div>
       </div>
     </form>
   </b-modal>
 </div>
</template>
<script>
export default {
 data() {
   return {
    recivers:[],
    countrys:[],
     form:new window.Form({
     search:''
           }),
     updateindex:-1,
     columns: [
       { label: "No" },
       { label: "Description" },
       { label: "Agent" },
       { label: "Currency" },
       { label: "Amount" },
        { label: "Created At", field: "created_at" },
       { label: "Manage" },
     ],
     expenses: {data:[]},
     users_holder:[],
     display: false,
     url: "",
     title:'',
     fee:'',
     code:'',
     selected_titles:[],
     isedit:-1,
     expense: new window.Form({
       country: "",
       user_id:'',
       amount:0,
       description:'',
       id: "",
     }),
   };
 },
 beforeMount() {
   this.getmyexpense()
   this.getcountry()
   this.getAllUsers()
 },
 methods: {
  formatNumber(value) {
    if (!value) return '0';
    return new Intl.NumberFormat('en-US').format(value);
  },
  updateuserholder(e){
    var id=e.target.value
    this.users_holder=[]
    this.users.forEach(element => {
      if(element.country.id==id){
        this.users_holder.push(element)
      }
    });
  },
  getAllUsers(page=1) {
   
      this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_users','variable':'users','params':'?page='+page}, { root: true }).then(() => {
        this.users=this.$store.getters['admin/Getusers'].data
      })
    },
    getcountry(){
    this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_expense','variable':'expense'}, { root: true }).then(() => {
      this.countrys=this.$store.getters['admin/Getexpense'].data
       
      })
  },
   attachmentprocessor (e) {
     var photos = e.target.files[0]
     var file = photos
     var limit = 1024 * 1024 * 2
     if (file.size <= limit) {
       this.expense.attachment = file
       this.url = URL.createObjectURL(file)
     }
   },
   FilterExpense(){
      this.$store.dispatch('admin/AdminController',{'data':{search:this.form.search},'method':'post','api':'admin_search_expense','variable':'expense'}, { root: true }).then(() => {
       this.expenses=this.$store.getters['admin/Getexpense']
     })
   },
   closemoadl(val){
     this.$bvModal.hide(val)
   },
   resetform() {
     this.expense.reset();
     this.url = "";
     this.display=false
     this.updateindex=-1
   },
   getimage(image){
     return window.image_url+image
   },
   Editexpense(expense,index) {
     this.expense.fill(expense);
     var id=expense.country.id
    this.users_holder=[]
    this.users.forEach(element => {
      if(element.country.id==id){
        this.users_holder.push(element)
      }
    });
     this.expense.user_id=expense.agent.id
     this.expense.country=expense.country.id
     this.display = true;
     this.updateindex=index
   },
   getmyexpense(page=1) {
     this.$store.dispatch('admin/AdminController',{'data':{},'method':'get','api':'admin_get_rate','variable':'expense','params':'?page='+page}, { root: true }).then(() => {
       this.expenses=this.$store.getters['admin/Getexpense']
     })
   },
   deleteexpense(id,index) {
     window.Swal.fire({
           title: 'are you sure',
           text: 'you want to delete this expense',
           icon: 'warning',
           showCancelButton: true,
           confirmButtonColor: '#3085d6',
           cancelButtonColor: '#d33',
           confirmButtonText: 'Yes'
         }).then((result) => {
           if (result.value) {
             this.$store.dispatch('admin/AdminController',{'data':{},'method':'delete','api':'admin_delete_rate','variable':'status','params':id}, { root: true }).then(() => {
        window.Toast.fire({
           icon: "success",
           title:'expense deleted successfuly',
         });
       this.expenses.data.splice(index,1)
     }).catch(()=>{
        window.Toast.fire({
           icon: "error",
           title:"expense can't be deleted !!",
         });
     })
           }
    });
   },
   update() {
    var form =window.VFToF(this.expense);
     console.log(form)

     this.$store
       .dispatch('admin/AdminController',{'data':form,'method':'post','api':'admin_update_rate','variable':'expense'}, { root: true })
       .then(() => {
         var data = this.$store.getters["admin/Getexpense"];
         this.expenses.data[this.updateindex].id=data.id
         this.expenses.data[this.updateindex].country=data.country
         this.expenses.data[this.updateindex].agent=data.agent
         this.expenses.data[this.updateindex].amount=data.amount
         this.expenses.data[this.updateindex].description=data.description
         this.expenses.data[this.updateindex].created_at=data.created_at
         this.display = false;
         this.$bvModal.hide("post-update-modal-expense");
          window.Toast.fire({
           icon: "success",
           title:'expense updated successfuly',
         });
       })
       .catch((err) => {
         this.expense.errors.errors = err;
       });
   },
   create() {
     var form =window.VFToF(this.expense);
     this.$store.dispatch('admin/AdminController',{'data':form,'method':'post','api':'admin_create_rate','variable':'expense'}, { root: true }).then(() => {
         this.expenses.data.unshift(this.$store.getters["admin/Getexpense"]);
         this.display = false;
         this.$bvModal.hide("post-update-modal-expense");
         window.Toast.fire({
           icon: "success",
           title:'expense created successfuly',
         });
       })
       .catch((err) => {
         this.expense.errors.errors = err;
       });
   }
 },
};
</script>

<style scoped>
.search-controller{
 border-left:0;
 border-top-right-radius: 10px;
 border-bottom-right-radius: 10px;
}
::placeholder {
color: black;
 font-style: italic;
 font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
 font-size: 1em;
}
.grade-icon{
 color:#fbcf00;
 font-size: 1.5em;
}

.close{
   color:blacksmoke;
   opacity: 1;
}

.card {
 position: relative;
   display: flex;
   flex-direction: column;
   min-width: 0;
   word-wrap: break-word;
   background-color:white;
   background-clip: border-box;
   border: 0 solid #d9dee3;
   border-radius: 0.5rem;
}
.bg-gradient-danger{
 border-radius: 5px !important;
}
.bg-gradient-danger:hover{
 background:transparent !important;
 color:white;
}
.bg-gradient-danger:hover .top-1{
  position: relative;
 visibility:visible;
 top:0;
 width:100%;
 border:0;
 border-top:1.5px solid blue;
}
.bg-gradient-danger:hover .top-2{
position: relative;
 visibility:visible;
 bottom:0;
 float:right;
 width:100%;
 border-bottom:1.5px solid blue;  
}
.top-1{
 position: relative;
 visibility:hidden;
 top:0;
 width:20%;
 border:0;
 z-index: 0;
 border-top:1px solid blue;
 transition: all 0.700s;
 padding-bottom: 10px;
}
.top-2{
 position: relative;
 z-index: 0;
 visibility:hidden;
 bottom:0;
 float:right;
 width:20%;
 border:0;
 border-bottom:1px solid blue;
 transition: all 0.700s;
 padding-top:10px;
}


.panel{
    /*background: linear-gradient(to right, #570827,#2b0112);*/
   background: linear-gradient(to right, #0f2027, #203a43, #2c5364);

 padding: 0;
 border-radius: 10px;
 border: none;
 box-shadow: 0 0 0 5px rgba(0,0,0,0.05),0 0 0 10px rgba(0,0,0,0.05);
}
.panel .panel-heading{
 padding: 20px 15px;
 border-radius: 10px 10px 0 0;
 margin: 0;
}
.panel .panel-heading .title{
 color: #fff;
 font-size: 28px;
 font-weight: 500;
 text-transform: capitalize;
 line-height: 40px;
 margin: 0;
}
.panel .panel-heading .btn{
 color: rgba(255,255,255,0.5);
 background: transparent;
 font-size: 16px;
 text-transform: capitalize;
 border: 2px solid #fff;
 border-radius: 50px;
 transition: all 0.3s ease 0s;
}
.panel .panel-heading .btn:hover{
 color: #fff;
 text-shadow: 3px 3px rgba(255,255,255,0.2);
}
.panel .panel-heading .form-control{
 color: #fff;
 background-color: transparent;
 width: 35%;
 height: 40px;
 border: 2px solid #fff;
 border-radius: 20px;
 display: inline-block;
 transition: all 0.3s ease 0s;
}
.panel .panel-heading .form-control:focus{
 background-color: rgba(255,255,255,0.2);
 box-shadow: none;
 outline: none;
}
.panel .panel-heading .form-control::placeholder{
 color: rgba(255,255,255,0.5);
 font-size: 15px;
 font-weight: 500;
}
.panel .panel-body{ padding: 0; }
.panel .panel-body .table thead tr th{
 color: #fff;
 background-color: rgba(255, 255, 255, 0.2);
 font-size: 16px;
 font-weight: 500;
 text-transform: uppercase;
 padding: 12px;
 border: none;
}
.panel .panel-body .table tbody tr td{
 color: #fff;
 font-size: 15px;
 padding: 10px 12px;
 vertical-align: middle;
}
.panel .panel-body .table tbody tr:nth-child(even){ background-color: rgba(255,255,255,0.05); }
.panel .panel-body .table tbody .action-list{
 padding: 0;
 margin: 0;
 list-style: none;
}
.panel .panel-body .table tbody .action-list li{
 display: inline-block;
 margin: 0 5px;
}
.panel .panel-body .table tbody .action-list li a{
 color: #fff;
 font-size: 15px;
 position: relative;
 z-index: 1;
 transition: all 0.3s ease 0s;
}
.panel .panel-body .table tbody .action-list li a:hover{ text-shadow: 3px 3px 0 rgba(255,255,255,0.3); }
.panel .panel-body .table tbody .action-list li a:before,
.panel .panel-body .table tbody .action-list li a:after{
 content: attr(data-tip);
 color: #fff;
 background-color: #111;
 font-size: 12px;
 padding: 5px 7px;
 border-radius: 4px;
 text-transform: capitalize;
 display: none;
 transform: translateX(-50%);
 position: absolute;
 left: 50%;
 top: -32px;
 transition: all 0.3s ease 0s;
}
.panel .panel-body .table tbody .action-list li a:after{
 content: '';
 height: 15px;
 width: 15px;
 padding: 0;
 border-radius: 0;
 transform: translateX(-50%) rotate(45deg);
 top: -18px;
 z-index: -1;
}
.panel .panel-body .table tbody .action-list li a:hover:before,
.panel .panel-body .table tbody .action-list li a:hover:after{
 display: block;
}
.panel .panel-footer{
 color: #fff;
 background-color: transparent;
 padding: 15px;
 border: none;
}
.panel .panel-footer .col{ line-height: 35px; }
.pagination{ margin: 0; }
.pagination li a{
 color: #fff;
 background-color: transparent;
 border: 2px solid transparent;
 font-size: 18px;
 font-weight: 500;
 text-align: center;
 line-height: 31px;
 width: 35px;
 height: 35px;
 padding: 0;
 margin: 0 3px;
 border-radius: 50px;
 transition: all 0.3s ease 0s;
}
.pagination li a:hover{
 color: #fff;
 background-color: transparent;
 border-color: rgba(255,255,255,0.2);
}
.pagination li a:focus,
.pagination li.active a,
.pagination li.active a:hover{
 color: #fff;
 background-color: transparent;
 border-color: #fff;
}
.pagination li:first-child a,
.pagination li:last-child a{
 border-radius: 50%;
}
@media only screen and (max-width:767px){
 .panel .panel-heading .title{
     text-align: center;
     margin: 0 0 10px;
 }
 .panel .panel-heading .btn_group{ text-align: center; }
}
</style>